

import { API_CENTRE } from "./config";
import _o2sService from "./_o2sServices";
import { IFilter } from "../models/filters/filter";
import { IMovementTypeFilter } from "../models/filters/movementTypeFilter";
import { IMovementTypeForm } from "../models/forms/movementTypeForm";
import { IMovementTypePDTO } from "../models/dtos/movementTypePDTO";

export default class MovementTypeService extends _o2sService {

    protected static override mainUrl:string = API_CENTRE + "/api/v1/MovementType";

    protected static override  getUrlFilter<F extends IMovementTypeFilter>(filter?: F):string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null)
        {
            if(filter.way != undefined)
                url += `&Way=${filter.way}`;
        }
        
        return url;
    }

    public static override toDTO(obj:IMovementTypeForm):IMovementTypePDTO {
        const dto = super.toDTO(obj) as IMovementTypePDTO;
        return dto;
    }
}